import {zonesByRegion} from "@casas-diamante/types"

export const CDBLUE = "#00aeef"
export const CDGREEN = "#00b140"
export const CDGRAYTEXT = "#6A7280"

export const zones = [...zonesByRegion["aca"], "Ciudad de México", "Puebla"]

export const inmAndCondStyles = {
   mainDiv: "h-[88vh] overflow-y-scroll",
   loading: "text-center text-xl font-bold mt-20",
   secondaryDiv: "flex flex-col flex-wrap mt-10 items-center",
   searchForm: "flex items-center content-center w-[50%] space-x-4 mt-5",
   searchBtn: "border rounded bg-blue-600 text-white font-bold p-2",
   cardContainer: "grid self-center w-full gap-[20px]",
   paginationDiv: "my-8",
}

export const inmAndCondIndStyles = {
   disponibilidadBtn:
      "border rounded bg-green-600 font-bold text-sm text-white p-1 text-center mb-5",
   gridDivs: "border rounded shadow-lg mr-4 p-4 text-sm overflow-y-scroll h-40",
   h5Titles: "font-semibold mb-1 text-sm",
   iconColors: "text-green",
   caracteristicas: "flex flex-wrap space-x-3 text-sm mt-2",
}

export const grayFormStyle =
   "bg-gray-100 border border-gray-300 shadow-lg flex flex-col items-center p-10 w-[90vw] md:w-[50vw] md:max-w-[800px] rounded-md text-center gap-4 mb-20"

const LOCAL = "http://localhost:8080"
const DEV = "https://testserver.casasdiamante.com"
const PROD = "https://server.casasdiamante.com"
const IMGS_TEST_URL = "https://testimages.casasdiamante.com"
const IMGS_PROD_URL = "https://images.casasdiamante.com"

const env = process.env.REACT_APP_ENV

export const IMAGES_URL = env === "production" ? IMGS_PROD_URL : IMGS_TEST_URL

const setApiURL = () => {
   if (process.env.REACT_APP_API_URL) {
      return process.env.REACT_APP_API_URL
   }
   switch (env) {
      case "production":
         return PROD
      case "development":
         return DEV
      default:
         return LOCAL
   }
}

export const API_URL = setApiURL()

export const CLIENTS_PROD = "https://casasdiamante.com"
export const CLIENTS_TEST = "https://test.casasdiamante.com"
export const OLDCAD_URL = "https://casasacapulcodiamante.mx"
export const PROD_URL = "https://socios.casasdiamante.com"

export const REDIRECT_URL = env === "production" ? CLIENTS_PROD : CLIENTS_TEST

/**
 * @description This is the data used for rendering the top section menu in the condos page.
 */
export const CONDO_SECTIONS = [
   {title: "Información", id: "condo-description"},
   {title: "Archivos", id: "condo-files"},
   {title: "Inmuebles", id: "condo-properties"},
   {title: "Imágenes", id: "condo-images"},
   {title: "Videos", id: "condo-videos"},
   {title: "Ubicación", id: "condo-location"},
]
